import {
    EchoCommand,
    EchoCommandOutput,
    SubmitOnboardingRequestCommand,
    SubmitOnboardingRequestOutput,
    SubmitOnboardingRequestInput,
    GetOnboardedTeamsCommand,
    GetOnboardedTeamsCommandOutput,
    DependencySentinelClient,
    GetTeamPackageListCommandInput,
    GetTeamPackageListCommandOutput,
    GetTeamPackageListCommand,
    GetPackageDependencyListCommand,
    GetPackageDependencyListCommandInput,
    GetPackageDependencyListCommandOutput,
    GetTeamPipelinesCommand,
    GetTeamPipelinesCommandOutput,
    GetPipelinePackagesCommand,
    GetPipelinePackagesCommandOutput,
    GetCodeReviewsByTeamCommand,
    GetCodeReviewsByTeamCommandOutput,
    SubmitPackageDryRunUpgradesCommand,
    SubmitPackageDryRunUpgradesCommandOutput,
    GetPackageDryRunUpgradesResultCommand,
    GetPackageDryRunUpgradesResultCommandOutput,
    GetUserPipelinesCommand,
    GetUserPipelinesCommandOutput,
} from "@amzn/dependencysentinel";
import { logging } from "src/core/util/log";
import { UserIdentity } from "src/core/auth/types";
interface BaseControllerProps {
  userIdentity: UserIdentity;
  sentinelClient: DependencySentinelClient;
}
export abstract class BaseController {
    client: DependencySentinelClient;
    userIdentity: UserIdentity;
    constructor(props: BaseControllerProps) {
        logging.log("Initializing BaseController");
        logging.log(JSON.stringify(props));
        this.userIdentity = props.userIdentity;
        this.client = props.sentinelClient;
        logging.log("initialized SentinelClient");
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    protected async _send<T>(command: (credentials: any) => any): Promise<T> {
        const request = command(this.userIdentity);
        const response = this.client.send(request);
        return response as T;
    }
}
export class SentinelController extends BaseController {
    public async echo(message: string) {
        const response = await this._send<EchoCommandOutput>(
            () => new EchoCommand({ string: message }),
        );
        return response ?? null;
    }

    public async submitOnboardingRequest(onboardingRequestInput: SubmitOnboardingRequestInput) {
        const response = await this._send<SubmitOnboardingRequestOutput>(
            () => new SubmitOnboardingRequestCommand(onboardingRequestInput),
        );
        return response ?? null;
    }

    public async getOnboardedTeams(requesterId?: string) {
        const response = await this._send<GetOnboardedTeamsCommandOutput>(
            () => new GetOnboardedTeamsCommand({ requesterId }),
        );
        return response ?? null;
    }

    public async getTeamPipelines(teamId: string) {
        const response = await this._send<GetTeamPipelinesCommandOutput>(
            () => new GetTeamPipelinesCommand({ teamId }),
        );
        return response ?? null;
    }

    public async getPipelinePackages(pipelineName: string) {
        const response = await this._send<GetPipelinePackagesCommandOutput>(
            () => new GetPipelinePackagesCommand({ pipelineName }),
        );
        return response ?? null;
    }

    public async getCodeReviewsByTeam(teamName: string) {
        const response = await this._send<GetCodeReviewsByTeamCommandOutput>(
            () => new GetCodeReviewsByTeamCommand({ teamName }),
        );
        return response ?? null;
    }

    public async getTeamPackageList(teamPackageListInput: GetTeamPackageListCommandInput) {
        const response = await this._send<GetTeamPackageListCommandOutput>(
            () => new GetTeamPackageListCommand(teamPackageListInput),
        );
        return response ?? null;
    }

    public async getPackageDependencyList(packageDependencyListInput: GetPackageDependencyListCommandInput) {
        const response = await this._send<GetPackageDependencyListCommandOutput>(
            () => new GetPackageDependencyListCommand(packageDependencyListInput),
        );
        return response ?? null;
    }

    public async submitPackageDryRunUpgrades(packageName: string) {
        const response = await this._send<SubmitPackageDryRunUpgradesCommandOutput>(
            () => new SubmitPackageDryRunUpgradesCommand({ packageName }),
        );
        return response ?? null;
    }

    public async getPackageDryRunUpgradesResult(requestId: string) {
        const response = await this._send<GetPackageDryRunUpgradesResultCommandOutput>(
            () => new GetPackageDryRunUpgradesResultCommand({ requestId }),
        );
        return response ?? null;
    }

    public async getUserPipelines(userId: string) {
        const response = await this._send<GetUserPipelinesCommandOutput>(
            () => new GetUserPipelinesCommand({ userId }),
        );
        return response ?? null;
    }
}
